<template>
  <div
    v-if="showLoadingState < 4"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="assetSignedStudentsContents"
    class="m-edition-section-content-subject m-edition-asset-contents"
  >
    <div class="student-access-info">
      <div class="student-access-info-academy">
        <AtomAvatarSecondary
          avatar-class="xlarge"
          :user-image="alumno.avatar"
        />
        <p class="display-flex-column font-weight-light justify-content-center margin-zero">
          <span v-if="alumno.razon_social">
            <b>{{ alumno.razon_social }}</b>
          </span>
          <span class="font-size-small">
            {{ alumno.email }}
          </span>
          <span class="font-size-small">
            Alta en Proyecto desde {{ $moment.parseZone(alumno.fecha).format('D MMMM YYYY') }}
          </span>
          <a
            v-if="alumno.activa"
            href="#"
            class="font-size-xsmall font-weight-bold text-link-hover-assets"
            @click.prevent="createAcademiaActorResetPassword"
          >
            <i
              v-if="!requests.createAcademiaActorResetPassword.isRequested"
              class="far fa-unlock-alt"
            >
            </i>
            <i
              v-else
              class="far fa-spinner fa-spin"
            >
            </i> Reenviar acceso al proyecto
          </a>
        </p>
      </div>
      <div class="student-access-info-project">
        <span class="font-size-small margin-right-small">Acceso Activo:</span>
        <AtomTogglePrimary
          v-model="alumno.activa"
          :disabled="requests.updateInscripcionEstado.isRequested"
          :element-id="alumno.id_inscripcion"
          method="updateInscripcionEstado"
          name="activo"
          :show-loading="requests.updateInscripcionEstado.isRequested"
          sliderClass="a-toggle-slider-assets-primary"
          type="checkbox"
          @updateInscripcionEstado="updateInscripcionEstado"
        />
      </div>
    </div>

    <div class="student-enrollments-info">
      <h2>Inscripciones</h2>
      <ul class="a-list-clean font-weight-light">
        <li
          v-for="(inscripcion, index) in inscripciones"
          :key="index"
        >
          - Inscripción
          <span
            v-if="inscripcion.activo"
            class="font-weight-regular text-color-success"
          >
            activa
          </span>
          <span
            v-else
            class="font-weight-regular text-color-danger"
          >
            inactiva
          </span>
          <span v-if="inscripcion.alta_manual">
            creada de forma manual el día {{ $moment.parseZone(inscripcion.fecha).format('D MMMM YYYY') }}.
          </span>
          <span v-else>
            creada de forma automática mediante la venta de {{ inscripcion.concepto_venta }} el día {{ $moment.parseZone(inscripcion.fecha).format('D MMMM YYYY') }}.
            <a
              :href="`/${$t('rPaths.billing')}/${$t('mEditionMenu.billing.mySales.subject')}/${inscripcion.venta}/${$t('mEditionMenu.billing.mySales.children.record.subedition')}`"
              class="font-weight-bold text-link-hover-billing"
              target="_blank"
            >
              <i class="far fa-external-link-square-alt"></i> Ver Venta
            </a>
          </span>
        </li>
      </ul>
    </div>

    <!-- listado de nodos -->
    <div class="student-nodes-info">
      <h2>Contenidos <span class="progress">({{ parseInt(alumno.porcentaje_nodos_vistos).toFixed(0) }}% visto)</span></h2>
      <a
        v-if="nodosActivos.length < countAllNodos()"
        class="font-size-small font-weight-bold text-link-hover-assets"
        href="#"
        @click.prevent="activarContenidosAll"
      >
        <i
          v-if="!requests.activarContenidosAll.isRequested"
          class="far fa-check"
        >
        </i>
        <i
          v-else
          class="far fa-spinner fa-spin"
        >
        </i> Activar todos
      </a>
      <a
        v-else
        class="font-size-small font-weight-bold text-link-hover-assets"
        href="#"
        @click.prevent="desactivarContenidosAll"
      >
        <i
          v-if="!requests.desactivarContenidosAll.isRequested"
          class="far fa-check"
        >
        </i>
        <i
          v-else
          class="far fa-spinner fa-spin"
        >
        </i> Desactivar todos
      </a>
    </div>

    <MoleculeEditionAssetContentsTreeNode
      v-for="nodo in nodos"
      :key="nodo.id"
      :contenido="contenido"
      :info="{ nodosActivosInscripcion: [...nodosActivos] }"
      :is-child="false"
      :nodo="nodo"
      node-actions="StudentState"
      node-actions-class="displayed flex-end"
    />
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetSignedStudentsContents',

  components: {
    MoleculeEditionAssetContentsTreeNode: () => import('@/components/molecules/MoleculeEditionAssetContentsTreeNode')
  },

  props: {
    element: Object,
    elementCategorias: Array
  },

  data () {
    return {
      academiaId: '',
      alumno: {},

      buttonSecondary: {
        activeAll: {
          class: 'a-button-assets-secondary a-button-side font-size-small',
          component: '',
          icon: 'fas fa-check text-color-success',
          method: 'activarContenidosAll',
          text: this.$t('mEditionAssetSignedStudentsContents.buttonSecondary.text'),
          type: 'button'
        }
      },

      contenido: 0,
      contenidos: [],

      estados: [
        {
          class: 'font-size-small font-weight-regular text-color-danger',
          id: 0,
          name: 'Inactiva'
        },
        {
          class: 'font-size-small font-weight-regular text-color-success',
          id: 1,
          name: 'Activa'
        }
      ],

      inscripciones: [],

      inscripcionesTipo: [
        {
          id: 0,
          name: 'Inscripción Automática'
        },
        {
          id: 1,
          name: 'Inscripción Manual'
        }
      ],

      nodos: [],
      nodosActivos: [],
      nodosAll: [],

      requests: {
        activarContenidosAll: {
          isRequested: false
        },

        createAcademiaActorResetPassword: {
          isRequested: false
        },

        desactivarContenidosAll: {
          isRequested: false
        },

        updateInscripcionEstado: {
          isRequested: false
        }
      },

      showLoadingState: 0
    }
  },

  computed: {
    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    updatedData () {
      this.readInscripcionNodos()
    }
  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id
    this.alumno = Object.assign({}, this.$store.getters.getAssetSelectedStudent)
    if (Object.values(this.alumno).length) {
      this.readContenidos()
      this.readInscripcionesAlumnoProyecto()
    } else {
      this.$router.push(`/${this.$t('rPaths.asset')}/${this.$route.params.id}/${this.$t('mEditionMenu.asset.signedStudents.subject')}`)
    }
  },

  methods: {
    activarContenidosAll () {
      if (!this.requests.activarContenidosAll.isRequested) {
        this.requests.activarContenidosAll.isRequested = true
        this.nodos.forEach(nodo => this.setNodosAll(nodo))
        this.$services.update('inscripcion', 'updateInscripcionNodoEstado', { 'nodos': [...this.nodosAll] }, [this.$route.params.subid])
          .then(response => {
            this.readContenidoNodos()
            this.requests.activarContenidosAll.isRequested = false
            this.$alerts.pushAlert('mEditionAssetSignedStudentsContents', 'activarContenidosAll', 'success')
            this.nodosAll = []
          })
          .catch(error => {
            console.log(error)
            this.requests.activarContenidosAll.isRequested = false
            this.$alerts.pushAlert('mEditionAssetSignedStudentsContents', 'activarContenidosAll', 'error', 'a-alert-danger')
          })
      }
    },

    countAllNodos () {
      let count = 0
      this.nodos.forEach(nodo => {
        count++
        if (nodo.children.length > 0) {
          nodo.children.forEach(child => {
            count++
            if (child.children.length > 0) {
              child.children.forEach(grandchild => {
                count++
              })
            }
          })
        }
      })
      return count
    },

    createAcademiaActorResetPassword () {
      if (!this.requests.createAcademiaActorResetPassword.isRequested) {
        this.requests.createAcademiaActorResetPassword.isRequested = true
        this.$services.create('academia', 'createAcademiaActorResetPassword', {}, [this.academiaId, this.alumno.alumno])
          .then(response => {
            this.$alerts.pushAlert('mEditionAssetSignedStudents', 'createAcademiaActorResetPassword', 'success')
            this.requests.createAcademiaActorResetPassword.isRequested = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionAssetSignedStudents', 'createAcademiaActorResetPassword', 'error', 'a-alert-danger')
            this.requests.createAcademiaActorResetPassword.isRequested = false
          })
      }
    },

    desactivarContenidosAll () {
      if (!this.requests.desactivarContenidosAll.isRequested) {
        this.requests.desactivarContenidosAll.isRequested = true
        this.nodos.forEach(nodo => this.unsetNodosAll(nodo))
        this.$services.update('inscripcion', 'updateInscripcionNodoEstado', { 'nodos': [...this.nodosAll] }, [this.$route.params.subid])
          .then(response => {
            this.readContenidoNodos()
            this.requests.desactivarContenidosAll.isRequested = false
            this.$alerts.pushAlert('mEditionAssetSignedStudentsContents', 'desactivarContenidosAll', 'success')
            this.nodosAll = []
          })
          .catch(error => {
            console.log(error)
            this.requests.desactivarContenidosAll.isRequested = false
            this.$alerts.pushAlert('mEditionAssetSignedStudentsContents', 'desactivarContenidosAll', 'error', 'a-alert-danger')
          })
      }
    },

    getEstadoClass (idEstado) {
      return this.estados.find(estado => estado.id === +idEstado).class
    },

    getEstadoName (idEstado) {
      return this.estados.find(estado => estado.id === +idEstado).name
    },

    getInscripcionTipo (idInscTipo) {
      return this.inscripcionesTipo.find(insc => insc.id === +idInscTipo).name
    },

    readContenidos () {
      this.$services.read('contenido', 'readContenidos', {}, [this.$route.params.id])
        .then(response => {
          this.contenidos = response.data
          // versión creada by default al crear el proyecto
          this.contenido = this.contenidos[0]
          this.readContenidoNodos()
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readContenidoNodos () {
      this.$services.read('contenido', 'readContenidoNodos', {}, [this.contenido.id])
        .then(response => {
          this.nodos = response.data
          this.readInscripcionNodos()
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readInscripcionNodos () {
      this.$services.read('inscripcion', 'readInscripcionNodos', {}, [this.$route.params.subid])
        .then(response => {
          this.nodosActivos = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readInscripcionesAlumnoProyecto () {
      this.$services.read('inscripcion', 'readInscripcionesAlumnoProyecto', {}, [this.alumno.alumno, this.$route.params.id])
        .then(response => {
          this.inscripciones = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    setNodosAll (nodo) {
      if (!(this.nodosActivos.some(nodoActivo => nodoActivo.nodo === nodo.id))) {
        this.nodosAll.push(nodo.id)
      }

      if (nodo.children.length > 0) {
        nodo.children.forEach(child => {
          this.setNodosAll(child)
        })
      }
    },

    unsetNodosAll (nodo) {
      this.nodosAll.push(nodo.id)
      if (nodo.children && nodo.children.length > 0) {
        nodo.children.forEach(hijo => this.unsetNodosAll(hijo))
      }
    },

    updateInscripcionEstado (element) {
      if (!this.requests.updateInscripcionEstado.isRequested) {
        this.requests.updateInscripcionEstado.isRequested = true
        this.$services.update('inscripcion', 'updateInscripcionEstado', { estado: element.state }, [element.id])
          .then(response => {
            this.$alerts.pushAlert('mEditionAssetSignedStudents', 'updateInscripcionEstado', response.data.activo ? 'activationSuccess' : 'deactivationSuccess')
            this.requests.updateInscripcionEstado.isRequested = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionAssetSignedStudents', 'updateInscripcionEstado', 'error', 'a-alert-danger')
            this.requests.updateInscripcionEstado.isRequested = false
          })
      }
    }
  }
}
</script>

<style scoped>
.student-access-info,
.student-enrollments-info,
.student-nodes-info  {
  background-color: var(--color-white);
  border-radius: var(--radius-medium);
  display: flex;
  padding: var(--spacing-medium) var(--spacing-small);
  width: calc(100% - var(--spacing-small) - var(--spacing-small));
}

.student-access-info {
  flex-direction: row;
  margin-bottom: var(--spacing-medium);

  & .student-access-info-academy {
    display: flex;
    flex-direction: row;
    width: 60%;
  }

  & .student-access-info-project {
    align-items: center;
    display: flex;
    flex-direction: row;
    font-weight: lighter;
    justify-content: end;
    width: 40%;
  }
}

.student-enrollments-info  {
  flex-direction: column;
  font-size: var(--font-size-small);
  margin-bottom: var(--spacing-medium);
  padding-bottom: 0;

  & h2 {
    font-size: var(--font-size-medium);
    margin: 0;
  }
}

.student-nodes-info  {
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: var(--spacing-xsmall);

  & h2 {
    font-size: var(--font-size-medium);
    margin: 0;

    & .progress {
      color: var(--color-black-45);
      font-size: var(--font-size-xsmall);
    }
  }
}
</style>
